import { FileUploadInfo } from "interfaces/models";
import { getPreSignUrl, isBase64 } from "./file";

export const checkIsImageExists = async (imgUrl: string): Promise<boolean> => {
  if (!imgUrl) {
    return false;
  }

  return new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.src = imgUrl;
  });
};

export const getUrlDisplayOfFileUpload = async (
  images: FileUploadInfo[]
): Promise<string[]> => {
  const urls = await Promise.all(
    (images || [])?.map(async (image) => {
      const src = image?.originSrc || image?.src || "";
      if (!src || isBase64(src)) {
        return "";
      }

      return await getPreSignUrl(src, "").catch(() => "");
    })
  );

  return urls;
};
